/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseListingsItemResponse
 */
export interface ResponseListingsItemResponse {
    /**
     * 
     * @type {string}
     * @memberof ResponseListingsItemResponse
     */
    asin?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseListingsItemResponse
     */
    condition?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseListingsItemResponse
     */
    createdDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseListingsItemResponse
     */
    fnsku?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseListingsItemResponse
     */
    itemName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponseListingsItemResponse
     */
    jan?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ResponseListingsItemResponse
     */
    mainImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseListingsItemResponse
     */
    packageQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseListingsItemResponse
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponseListingsItemResponse
     */
    status?: Array<string>;
}

/**
 * Check if a given object implements the ResponseListingsItemResponse interface.
 */
export function instanceOfResponseListingsItemResponse(value: object): value is ResponseListingsItemResponse {
    return true;
}

export function ResponseListingsItemResponseFromJSON(json: any): ResponseListingsItemResponse {
    return ResponseListingsItemResponseFromJSONTyped(json, false);
}

export function ResponseListingsItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListingsItemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'asin': json['asin'] == null ? undefined : json['asin'],
        'condition': json['condition'] == null ? undefined : json['condition'],
        'createdDate': json['createdDate'] == null ? undefined : json['createdDate'],
        'fnsku': json['fnsku'] == null ? undefined : json['fnsku'],
        'itemName': json['itemName'] == null ? undefined : json['itemName'],
        'jan': json['jan'] == null ? undefined : json['jan'],
        'mainImageUrl': json['mainImageUrl'] == null ? undefined : json['mainImageUrl'],
        'packageQuantity': json['package_quantity'] == null ? undefined : json['package_quantity'],
        'sku': json['sku'] == null ? undefined : json['sku'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function ResponseListingsItemResponseToJSON(json: any): ResponseListingsItemResponse {
    return ResponseListingsItemResponseToJSONTyped(json, false);
}

export function ResponseListingsItemResponseToJSONTyped(value?: ResponseListingsItemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'asin': value['asin'],
        'condition': value['condition'],
        'createdDate': value['createdDate'],
        'fnsku': value['fnsku'],
        'itemName': value['itemName'],
        'jan': value['jan'],
        'mainImageUrl': value['mainImageUrl'],
        'package_quantity': value['packageQuantity'],
        'sku': value['sku'],
        'status': value['status'],
    };
}

